import { gql } from '@apollo/client';
import Grid from '@mui/material/Unstable_Grid2';

import { AxleInfoField } from '../../components/displayFields/AxleInfoField';

export const ClinicianVisitPerformanceFragment = gql`
    fragment ClinicianVisitPerformance on ClinicianVisitPaginatedList {
        performance {
            id
            averageRating
            percentOnTime
            percentRequiringReschedule
        }
    }
`;
export interface IClinicianVisitPerformanceStatsFragment {
    id: string;
    averageRating: number | null;
    percentOnTime: number | null;
    percentRequiringReschedule: number | null;
}

const displayPercent = (percent: number | null) => {
    if (percent === null) {
        return 'N/A';
    }
    return `${(percent * 100).toFixed(2)}%`;
};

export const ClinicianPerformanceStats = ({
    performance,
    totalCount,
    mileage,
}: {
    performance: IClinicianVisitPerformanceStatsFragment | null;
    mileage: number;
    totalCount: number;
}) => {
    return (
        <Grid
            container
            sx={{
                textAlign: 'center',
                '& label': {
                    whiteSpace: 'pre-line',
                    margin: '0 auto',
                },
            }}
        >
            <Grid xs={1} md={1} />
            <Grid xs={5} md={2}>
                <AxleInfoField
                    label={'Number\nof Visits'}
                    value={totalCount.toString()}
                    isValueBig={true}
                />
            </Grid>
            <Grid xs={5} md={2}>
                <AxleInfoField
                    label={'Distance\nTraveled'}
                    value={`${mileage} mi`}
                    isValueBig={true}
                />
            </Grid>
            <Grid xs={1} md={0} />
            {performance && (
                <>
                    <Grid xs={4} md={2}>
                        <AxleInfoField
                            label={'On-time\nPerformance'}
                            value={displayPercent(performance.percentOnTime)}
                            isValueBig={true}
                        />
                    </Grid>
                    <Grid xs={4} md={2}>
                        <AxleInfoField
                            label={'Requires\nReschedule'}
                            value={displayPercent(performance.percentRequiringReschedule)}
                            isValueBig={true}
                        />
                    </Grid>
                    <Grid xs={4} md={2}>
                        <AxleInfoField
                            label={'Average\nRating'}
                            value={
                                performance.averageRating
                                    ? `${performance.averageRating.toFixed(1)}`
                                    : 'No reviews'
                            }
                            isValueBig={true}
                        />
                    </Grid>
                    <Grid xs={0} md={1} />
                </>
            )}
        </Grid>
    );
};
